export default "__VITE_ASSET__BwDyb_WU__"